export default {
    app: {
        main_menu: {
            home: 'Dashboard',
            shared_records: 'Shared records',
            referrals: 'Referrals',
            referrals_received: 'Received',
            referrals_made: 'Made',
            availability: 'Availability',
            availability_main_location: 'Main location',
            practice: 'Practice',
            practice_members: 'Members',
            practice_profile: 'Profile',
            practice_hours: 'Practice hours',
            my_hours: 'My hours',
            network: 'My Network',
            network_intelligence: 'Network Intelligence',
            governance: 'Broadcast Governance',
            network_members: 'Member Directory',
            network_favorites: 'Favorites',
            network_browse: 'Browse',
            network_invite_physicians: 'Invite providers',
            network_invite_service_providers: 'Invite service providers',
            network_invitations: 'My Invitations',
            claim_your_profile: 'Claim your profile',
            mma_invites_member: 'MMA invites member',
            plan_billing: 'Plan & billing',
            referrals_pool: 'Referrals pool',
            referrals_pool_received: 'Pool received',
            referrals_pool_made: 'Pool made',
            patients: 'Patients',
            patient_list: 'Patient List',
            upload: 'Upload',
        },
        sidenav: {
            current_physician: 'Current active provider',
        },
        availability_topnav: {
            referral_count: '{count} referrals',
            manage_availability: 'Manage Availability',
            manage_availability_short: 'Availability',
            select_slots: 'Select Slots',
            view: {
                daily: 'Daily',
                weekly: 'Weekly',
                monthly: 'Monthly',
            },
            legend: {
                confirmed: 'Confirmed',
                pending: 'Pending',
                cancelled_no_show: 'Cancelled/No Show',
                available: 'Available',
                not_available: 'Not Available',
            },
            mobile_title: 'MedMatch Network',
            select_slots_exit: 'Exit Selection',
            select_slots_hint: 'Click on any time slot to select (max {max})',
            selected_slots_title: 'Selected Time Slots ({count}/{max})',
            select_more: 'Select {count} more',
            selected_slots_clear_all: 'Clear All',
            selected_slot_placeholder: 'Slot {index}',
            confirm_selection: 'Confirm Selection',
            toast: {
                selection_activated: 'Selection mode activated. Click on time slots to select up to {max} slots.',
                slot_selected: 'Slot selected: {time} on {date}',
                slots_confirmed: 'Slots confirmed! Ready for booking.',
            },
        },
        topnav: {
            make_referal: 'Make a referral',
            track_referrals: 'Track referrals',
            direct_referral: 'Direct referral',
            provider_direct: 'Provider direct',
            provider_match: 'Provider match',
            direct_referral_description: 'Refer directly to a provider',
            match_referral: 'Match referral',
            patient_match: 'Patient match',
            patient_direct: 'Patient direct',
            match_referral_description: 'Match patient to a provider based on search criteria',
            received_referrals: 'Referrals received',
            made_referrals: 'Referrals made',
            direct_physican: 'Direct to Provider',
            direct_ancillary: 'Direct to Ancillary',
            match_physican: 'Match Provider',
            match_ancillary: 'Match Ancillary',
            eprescribe: 'Digital Referral Script',
            eprescribe_description: 'Send electronic prescriptions to your patient',
        },
        user_menu: {
            activate_physician: 'Activate Provider',
            search_member: 'Search {practice} member',
            location_scope: {
                my: 'My practice location',
                all: 'All practice locations',
            },
            manage_account: 'Manage personal account',
            manage_practice: 'Manage {practice} account',
            logout: 'Log out',
            profile: {
                my_profile: 'My Profile',
                manage_account: 'Manage {physicianFirstName} {physicianLastName} MD account',
            },
        },
        loading: {
            heading_one: 'We are preparing your personal experience',
            heading_two: 'Please hold on tight',
        },
    },
}
